import { PaginationResponse } from "../../Shared/Pagination/PaginationResponse";
import {
  deleteApi,
  getApi,
  postApi,
  putApi,
} from "../../Shared/Services/RestService";
import {
  SystemAnalyticsAdminRowDTO,
  SystemAnalyticsCommentDTO,
  SystemAnalyticsCommentRequest,
  SystemAnalyticsDeleteResultDTO,
  SystemAnalyticsSummaryDTO,
} from "../Types/SystemAnalyticsType";

const BASE = "/admin/system-analytics";

export const getSystemAnalyticsSummary = () =>
  getApi<SystemAnalyticsSummaryDTO>(`${BASE}/summary`);

export const getSystemAnalyticsComments = (
  search?: string,
  topic?: string,
  page: number = 0,
  size: number = 20
) => {
  // Omit empty filters rather than sending `search=`: the backend treats "" and null identically,
  // but a request with no search param is cheaper to log and cache.
  const params: Record<string, any> = { page, size };
  if (search) params.search = search;
  if (topic) params.topic = topic;

  return getApi<PaginationResponse<SystemAnalyticsCommentDTO>>(
    `${BASE}/comments`,
    params
  );
};

export const createSystemAnalyticsComment = (
  payload: SystemAnalyticsCommentRequest
) => postApi<SystemAnalyticsCommentDTO>(`${BASE}/comments`, payload);

export const updateSystemAnalyticsComment = (
  commentId: string,
  payload: SystemAnalyticsCommentRequest
) =>
  putApi<SystemAnalyticsCommentDTO>(`${BASE}/comments`, commentId, payload);

/**
 * The backend answers with an explicit result rather than an empty body, so this needs no
 * empty-body special case like the 204 data-service deletes.
 */
export const deleteSystemAnalyticsComment = (commentId: string) =>
  deleteApi<SystemAnalyticsDeleteResultDTO>(`${BASE}/comments`, commentId);

/** Admin roles only - the backend filters out candidates and recruiters. */
export const getSystemAnalyticsAdmins = (
  search?: string,
  role?: string,
  page: number = 0,
  size: number = 20
) => {
  const params: Record<string, any> = { page, size };
  if (search) params.search = search;
  if (role) params.role = role;

  return getApi<PaginationResponse<SystemAnalyticsAdminRowDTO>>(
    `${BASE}/admins`,
    params
  );
};